
export class AuthRoles {
    static ROLE_USER = 'ROLE_USER';
    static ROLE_ADMIN = 'ROLE_ADMIN';
    static ROLE_SELLER = 'ROLE_SELLER';
    static ROLE_SERVICE = 'ROLE_SERVICE';
    static ROLE_CUSTOM = 'ROLE_CUSTOM';
}
